<script setup lang="ts">
  import { Search } from "lucide-vue-next";
  import { Input } from "@/components/ui/input";
  import type { IndexPageFiltersProps } from "./types";

  const props = withDefaults(defineProps<IndexPageFiltersProps>(), {
    searchPlaceholder: "Search...",
    searchModelValue: "",
    searchClass: "w-60",
    searchDataCy: undefined,
  });

  const emit = defineEmits<{
    "update:searchModelValue": [value: string];
  }>();
</script>

<template>
  <div class="flex items-center gap-1 text-sm">
    <slot name="filters" />
    <Input
      :model-value="props.searchModelValue"
      :placeholder="props.searchPlaceholder"
      :icon="Search"
      clearable
      class="rounded-lg border-0 bg-secondary shadow-none [&>svg]:text-foreground-subtle [&_input]:placeholder:text-foreground-subtle"
      :class="props.searchClass"
      :data-cy="props.searchDataCy"
      @update:model-value="emit('update:searchModelValue', String($event))" />
    <div
      v-if="$slots.actions"
      class="ml-auto flex items-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>
